import { SVGProps, Ref, forwardRef, useId } from 'react';

export const MaxBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <mask
                        id={`${_uniqueId}mask0_17073_742`}
                        style={{
                            maskType: 'alpha',
                        }}
                        maskUnits="userSpaceOnUse"
                        x={0}
                        y={0}
                        width={16}
                        height={16}
                        suppressHydrationWarning
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.158 15.253c-1.44 0-2.109-.21-3.271-1.05-.736.945-3.065 1.684-3.166.42 0-.948-.21-1.749-.448-2.623C.989 10.922.667 9.721.667 7.982.667 3.83 4.077.706 8.119.706c4.045 0 7.214 3.278 7.214 7.316a7.2 7.2 0 0 1-2.09 5.098 7.22 7.22 0 0 1-5.085 2.133m.06-10.958c-1.969-.101-3.503 1.26-3.843 3.394-.28 1.767.218 3.919.641 4.03.203.05.715-.363 1.033-.682.527.364 1.141.582 1.78.634a3.75 3.75 0 0 0 3.918-3.489A3.74 3.74 0 0 0 8.217 4.3z"
                            fill="#4FBCFC"
                        />
                    </mask>
                    <g mask={`url(#${_uniqueId}mask0_17073_742)`} suppressHydrationWarning>
                        <g filter={`url(#${_uniqueId}filter0_f_17073_742)`} suppressHydrationWarning>
                            <path
                                d="M16.111 6.778c0 5.4-4.377 9.778-9.778 9.778-5.4 0-9.777-4.378-9.777-9.778S.933-3 6.333-3s9.778 4.378 9.778 9.778"
                                fill="#2A40F1"
                            />
                            <path
                                d="M27.111-1.167c0 5.4-4.377 9.778-9.777 9.778S7.556 4.234 7.556-1.167c0-5.4 4.377-9.777 9.778-9.777 5.4 0 9.777 4.377 9.777 9.777"
                                fill="#8950E1"
                            />
                            <path
                                d="M10 17.778c0 5.4-4.378 9.778-9.778 9.778s-9.777-4.378-9.777-9.778S-5.178 8 .222 8 10 12.378 10 17.778"
                                fill="#4AC1FC"
                            />
                            <path
                                d="M27.722 15.333c0 5.4-4.377 9.778-9.777 9.778s-9.778-4.378-9.778-9.778 4.377-9.777 9.778-9.777c5.4 0 9.777 4.377 9.777 9.777"
                                fill="#A261DF"
                            />
                        </g>
                    </g>
                </g>
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_f_17073_742`}
                    x={-17.072}
                    y={-18.461}
                    width={52.311}
                    height={53.533}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={3.758} result="effect1_foregroundBlur_17073_742" />
                </filter>
            </defs>
        </svg>
    );
});
MaxBrandSize16Glyph.displayName = 'MaxBrandSize16Glyph';
